import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

export default function QRCodeGenerator({ value, tableNumber, label, type = 'table' }) {
    const downloadQRCode = () => {
        const qrCanvas = document.getElementById(`qr-gen-${tableNumber}`);
        
        // Create a new canvas for the composite image
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Set canvas dimensions (wider and taller to accommodate text)
        canvas.width = 400;
        canvas.height = 550;
        
        // Fill background with white
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Add border
        ctx.strokeStyle = '#e0e0e0';
        ctx.lineWidth = 2;
        ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);
        
        // Draw table/room number at top
        ctx.fillStyle = '#1976d2';
        ctx.font = 'bold 32px Arial';
        ctx.textAlign = 'center';
        const tableText = `${type === 'room' ? 'Room' : 'Table'} ${tableNumber}`;
        ctx.fillText(tableText, canvas.width / 2, 60);
        
        // Draw QR code in center
        const qrSize = 250;
        const qrX = (canvas.width - qrSize) / 2;
        const qrY = 90;
        ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
        
        // Draw instruction text below QR code
        ctx.fillStyle = '#333333';
        ctx.font = 'bold 18px Arial';
        ctx.fillText('Scan the QR code for', canvas.width / 2, qrY + qrSize + 40);
        ctx.fillText('menu and order', canvas.width / 2, qrY + qrSize + 65);
        
        // Draw website URL at bottom
        ctx.fillStyle = '#1976d2';
        ctx.font = 'bold 20px Arial';
        ctx.fillText('Or visit www.nyurwa.rw', canvas.width / 2, canvas.height - 40);
        
        // Convert to downloadable image
        const pngUrl = canvas.toDataURL("image/png");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${type}-${tableNumber}-qr.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <Card className="text-center h-100 shadow-sm">
            <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                <h5 className="card-title text-primary mb-3">{type === 'room' ? 'Room' : 'Table'} {tableNumber}</h5>
                <div className="p-3 bg-white border rounded mb-3">
                    <QRCodeCanvas
                        id={`qr-gen-${tableNumber}`}
                        value={value}
                        size={180}
                        level={"H"}
                        includeMargin={true}
                        imageSettings={{
                            src: "/logo.png",
                            x: undefined,
                            y: undefined,
                            height: 24,
                            width: 24,
                            excavate: true,
                        }}
                    />
                </div>
                {label && <p className="text-muted small">{label}</p>}
                <Button variant="outline-primary" size="sm" onClick={downloadQRCode}>
                    <i className="fas fa-download me-2"></i> Download QR
                </Button>
            </Card.Body>
        </Card>
    );
}